"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const nestedContentPopulation_1 = require("./nestedContentPopulation");
exports.updateNestedBlock = (path, blocks, newData, contentObj) => {
    // boolean is for "success"
    if (path.length === 0) {
        throw new Error('Cannot update nested block!');
    }
    // TODO: Remove anys
    const newPath = path.reduce((acc, idx, loopIdex) => {
        if (loopIdex !== path.length - 1) {
            return [...acc, idx, 'childBlocks'];
        }
        return [...acc, idx];
    }, []);
    const foundBlock = lodash_1.get(blocks, newPath);
    if (!foundBlock) {
        console.error('updateNestedBlock: no foundBlock', path, blocks);
        return [blocks, false];
    }
    let newBlock = Object.assign(Object.assign({}, foundBlock), newData);
    if (contentObj) {
        newBlock = nestedContentPopulation_1.nestedContentPopulation(foundBlock, contentObj.contentFeed, contentObj.contentItem, contentObj.contentSlotNumber);
    }
    return [lodash_1.set(blocks, newPath, newBlock), true];
};
//# sourceMappingURL=updateNestedBlock.js.map